import React, { useCallback, useEffect, useState } from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import { IconButton, Typography, Badge } from '@material-ui/core'
import { useIsPlacePendingActivateHasAccess } from 'app/auth/authHooks'
import { useSocket } from 'app/SocketContext'

const useStyles = makeStyles((theme) => ({
  memuButton: {
    display: 'flex',
    margin: 'auto',
    padding: '5px 8px',
    '& .MuiIconButton-label': {
      display: 'unset',
      textTransform: 'capitalize',
    },
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  iconBtn: {
    width: '50px',
    height: '38px',
    margin: 'auto',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.colors['secondary'],
      color: '#fff',
      fontSize: '10px',
      minWidth: '18px',
      height: '18px',
      padding: '0 4px',
    },
    '& .MuiBadge-anchorOriginTopRightRectangle': {
      top: '8px',
      right: '10px',
    },
  },
}))

export default (props) => {
  const { item } = props
  const socket = useSocket()
  const classes = useStyles()

  const [unreadCount, setUnreadCount] = useState(0)

  const { formatMessage } = useIntl()
  const isPendingActiveMenu = useIsPlacePendingActivateHasAccess()
  const managerWebHostname = process.env.REACT_APP_MANAGER_WEB_HOSTNAME

  const handleUnreadCount = useCallback(({ total = 0 }) => {
    setUnreadCount(total)
  }, [])

  const redirecTo = () => window.location.replace(`${managerWebHostname}/chats`)

  useEffect(() => {
    if (!socket?.socket || !socket.isConnected) return

    socket.socket.on('message:unreadCount', handleUnreadCount)

    return () => {
      socket.socket?.off('message:unreadCount', handleUnreadCount)
    }
  }, [socket?.socket, socket?.isConnected, handleUnreadCount])

  return (
    <IconButton
      disableRipple
      disabled={isPendingActiveMenu}
      className={classes.memuButton}
      onClick={() => redirecTo()}
      data-testid={`${item.id}-button-menu`}
    >
      <Badge badgeContent={unreadCount} className={classes.badge}>
        <div
          className={clsx(
            classes.iconBtn,
            'group-hover:bg-white hover:bg-white rounded-8',
            item.isSelected && 'bg-white',
          )}
        >
          {item.componentIcon && item.componentIcon}
        </div>
      </Badge>
      <Typography className="text-12 text-blue-950 font-normal">
        {formatMessage({
          id: item.localizedId,
        })}
      </Typography>
    </IconButton>
  )
}
